import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxLocationBulkSyncSummary,
  ISyncLocationsResult,
} from './types';

/**
 * Manually re-trigger the bulk Location → sales-tax sync for a corporation.
 * Wraps POST /new-sales-tax/locations/sync/:corporationId. The endpoint is
 * best-effort: it never throws on per-location failures — the failures land
 * in the returned summary so the UI can surface them without a thrown error.
 *
 * Use after fixing data issues (invalid postal codes, state codes) to retry
 * mirroring previously-failed locations.
 */
export async function syncLocationsForCorporation(
  corporationId: number
): Promise<ISyncLocationsResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/locations/sync/${corporationId}`,
      { method: 'POST' }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData?.message ?? response.statusText,
      };
    }

    const summary =
      (await response.json()) as IIndirectTaxLocationBulkSyncSummary;
    return { success: true, summary };
  } catch (error: unknown) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to sync locations to sales tax',
    };
  }
}
